<template>   
    <div class="row order-items-component">
        <div class="col-12">
            <h3 class="mb-1">{{ title }}</h3>
            <span class="text-danger" v-if="errors['items'] !== undefined">{{ errors.items[0] }}</span>
        </div>
        <div class="col-12">
            <table class="table table-bordered table-striped" :id="table_id">
                <thead>
                    <tr>
                        <th v-for="header in headers" :key="header.key">
                            {{ header.trans }}
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(item, item_index) in items" :key="item_index" :row_index="item_index">
                        <td>
                            <!-- Title -->
                            <input type="text" 
                                :class="'form-control form-control-sm input_' + headers[0]['key']" 
                                :name="'items['+item_index+']['+headers[0]['key']+']'" 
                                v-model="item[headers[0]['key']]"
                            >
                            <span class="text-danger" v-if="errors['items.'+item_index+'.'+headers[0]['key']] !== undefined">
                                {{ errors['items.'+item_index+'.'+headers[0]['key']][0].replace('items.'+item_index+'.'+headers[0]['key'], headers[0]['trans']) }}
                            </span>
                        </td>
                        <td>
                            <!-- Count -->
                            <input type="number" 
                                :class="'form-control form-control-sm input_' + headers[1]['key']" 
                                :name="'items['+item_index+']['+headers[1]['key']+']'" 
                                v-model="item[headers[1]['key']]"
                                @input="calculateSum"
                            >
                            <span class="text-danger" v-if="errors['items.'+item_index+'.'+headers[1]['key']] !== undefined">
                                {{ errors['items.'+item_index+'.'+headers[1]['key']][0].replace('items.'+item_index+'.'+headers[1]['key'], headers[1]['trans']) }}
                            </span>
                        </td>
                        <td>
                            <!-- Unit Price -->
                            <input type="number" 
                                :class="'form-control form-control-sm input_' + headers[2]['key']" 
                                :name="'items['+item_index+']['+headers[2]['key']+']'" 
                                v-model="item[headers[2]['key']]"
                                @input="calculateSum"
                            >
                            <span class="text-danger" v-if="errors['items.'+item_index+'.'+headers[2]['key']] !== undefined">
                                {{ errors['items.'+item_index+'.'+headers[2]['key']][0].replace('items.'+item_index+'.'+headers[2]['key'], headers[2]['trans']) }}
                            </span>
                        </td>
                        <td>
                            <!-- Total -->
                            <input type="number" 
                                :class="'form-control form-control-sm input_' + headers[3]['key']" 
                                :name="'items['+item_index+']['+headers[3]['key']+']'"
                                v-model="item[headers[3]['key']]"
                                disabled
                            >
                        </td>
                        <td class="shrink-cell">
                            <!-- Actions -->
                            <button type="button" class="btn btn-danger btn-sm mt-1" @click="deleteRow">
                                <i class="fa fa-times"></i>
                            </button>                            
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="col-12">
            <button type="button" class="btn btn-primary btn-sm" @click="addNewRow();">
                <i class="fa fa-plus"></i>
            </button>
        </div>
    </div>
</template>

<script>
export default {
    data: function(){
        return {
            'headers': [],
            'items': [],
            'errors': [],
        }
    },
    props: {
        'table_id': {
            'type': String,
            'required': true,
        },
        'headers_json': {
            'type': String,
            'required': true,
        },
        'items_json': {
            'type': String,
            'required': true,
        },
        'title': {
            'type': String,
            'required': true,
        },
        'errors_json': {
            'type': String,
            'required': true,
        },
    },
    created: function(){
        let vue = this;
        
        vue.headers = JSON.parse(Base64.decode(vue.headers_json));
        vue.items = JSON.parse(Base64.decode(vue.items_json));
        vue.errors = JSON.parse(Base64.decode(vue.errors_json));
        
        vue.headers.push({'key': 'actions', 'value': ''});

        $.each(vue.items, function(index, element){
            vue.items[index]['total'] =  (parseFloat(vue.items[index]['unit_price']) * parseFloat(vue.items[index]['count'])).toFixed(2);
        });

    },
    methods: {
        addNewRow: function(){
            let vue = this;

            let new_item = {};
            $.each(vue.headers, function(key, value){
                new_item[value.key] = '';
            });
            new_item['count'] = '1.00';
            new_item['unit_price'] = '1.00';
            new_item['total'] = '1.00';

            vue.items.push(new_item);
        },
        calculateSum: function(event){
            let vue = this;
            
            let item_index = $(event.target).parents('tr').first().attr('row_index');

            vue.items[item_index]['total'] = (parseFloat(vue.items[item_index]['unit_price']) * parseFloat(vue.items[item_index]['count'])).toFixed(2);
        },
        deleteRow: function(event){
            let vue = this;

            let item_index = $(event.target).parents('tr').first().attr('row_index');
            vue.items = vue.items.filter(function(value, index, array){
                return index != item_index;
            });
        },
    }
}
</script>
